// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import patients from './modules/patients'
import questionnaire from './modules/questionnaire'

Vue.use(Vuex)
Vue.use(VueResource)

const store = new Vuex.Store({
  modules: {
    questionnaire: questionnaire,
    patients: patients
  },
  state: {
    adminUsername: null,
    adminAuthToken: null,
    patientUsername: null,
    patientAuthToken: null
  },
  getters: {
    cardIdList: (state) => {
      return []
    }
  },
  mutations: {
    setAdminCredentials: (state, payload) => {
      state.adminAuthToken = payload.adminAuthToken
      state.adminUsername = payload.adminUsername

      // Allow only one JWT to exist in the store
      state.patientAuthToken = null
      state.patientUsername = null
    },
    setPatientCredentials: (state, payload) => {
      state.patientUsername = payload.patientUsername
      state.patientAuthToken = payload.patientAuthToken

      if (payload.patientAuthToken) {
        // Allow only one JWT to exist in the store
        state.adminAuthToken = null
        state.adminUsername = null
      }
    },
    setUserProfile: (state, payload) => {
      state.userProfile = Object.assign({}, payload)
    },
    clearStore: (state) => {
      state.adminUsername = null
      state.adminAuthToken = null
      state.patientUsername = null
      state.patientAuthToken = null
    }
  },
  actions: {
    saveAdminCredentials ({ commit }, payload) {
      return new Promise(resolve => {
        commit('setAdminCredentials', payload)
        resolve()
      })
    },
    savePatientCredentials ({ commit }, payload) {
      return new Promise(resolve => {
        commit('setPatientCredentials', payload)
        resolve()
      })
    },
    saveUserProfile ({ commit }, payload) {
      return new Promise(resolve => {
        commit('setUserProfile', payload)
        resolve()
      })
    },
    resetStore ({ commit }) {
      return new Promise(resolve => {
        commit('clearStore')
        resolve()
      })
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js